import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-capital-investment',
  templateUrl: './capital-investment.component.html',
  styleUrls: ['./capital-investment.component.css']
})
export class CapitalInvestmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
